import type { SignalEntity } from '../../lib/signal-model'

/** "3 min ago", "2 h ago", "4 d ago" — coarse on purpose; the absolute time sits beside it. */
export function agoLabel(at: number, now = Date.now()): string {
  const s = Math.max(0, Math.round((now - at) / 1000))
  if (s < 60) return `${s}s ago`
  const m = Math.round(s / 60)
  if (m < 60) return `${m} min ago`
  const h = Math.round(m / 60)
  if (h < 48) return `${h} h ago`
  return `${Math.round(h / 24)} d ago`
}

function quote(v: string): string {
  return `'${v.replace(/'/g, "''")}'`
}

/** `stream=SIGNALS where suspectuser = 'x' | duration 7d | limit 200` */
export function entitySearchQuery(e: SignalEntity): string {
  return `stream=SIGNALS where ${e.role.toLowerCase()}${e.field.toLowerCase()} = ${quote(e.value)} | duration 7d | limit 200`
}

export function copyText(text: string): Promise<boolean> {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(text).then(
      () => true,
      () => false,
    )
  }
  return Promise.resolve(false)
}

/**
 * The deep link to one signal: this page's URL with `?signal=<uuid>` and
 * nothing else from the query (no lens, tab or filters — the receiver's own
 * defaults apply).
 */
export function signalLink(uuid: string, href: string): string {
  const u = new URL(href)
  u.search = ''
  u.hash = ''
  u.searchParams.set('signal', uuid)
  return u.toString()
}
